<template>
  <div 
    class="gender-btns-container"
    :style="`width: ${width}; margin-left: ${`margin`}`"
  >
    <button 
      class="gender-item" 
      id="genderM"
      :class="value === GenderEnum.MALE ? 'selected' : ''"
      @click="handleGenderChange(GenderEnum.MALE)"
      tabindex="4"
      >
      남
    </button>
    <button 
      class="gender-item" 
      :class="value === GenderEnum.FEMALE ? 'selected' : ''"
      @click="handleGenderChange(GenderEnum.FEMALE)"
      tabindex="5"
    >
    여
  </button>
  <button 
    class="gender-item"
    :class="value === '' ? 'selected' : ''"
    @click="handleGenderChange()"
    tabindex="6"
    >
      입력 안 함
    </button>
  </div>
</template>
<script>
import { GenderEnum } from "@/enums/common.enums";
export default {
  props: {
    gender: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: '100%',
    },
    margin: {
      type: String,
      required: false,
      default: '0px',
    },
  },
  data() {
    return {
      GenderEnum,
      value: this.gender,
    }
  },
  watch: {
    gender(newValue) {
      this.value = newValue;
    }
  },
  methods: {
    async handleGenderChange(gender) {
      if(!gender) {
        this.value = '';
      } else {
        this.value = gender;
      }
      this.$emit('handleGenderChange', this.value);
    }

  }
}
</script>
<style scoped>
  .gender-btns-container {
    width: 100%;
    min-height: 40px;
    height: 40px;
    font-size: 15px;
    background-color: #F1F2F3;    
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    gap: 4px;
    flex: 1 0 0px;
    padding: 4px;
  }
  
  .gender-item {
    border-radius: 8px;
    flex: 1;
    border: none;
    box-shadow: none;
    height: 100%;
    transition: ease-in-out 0.3s;
    color: #8d939a;
  }
  .gender-item:hover {
    transition: ease-in-out 0.3s;
    background-color: rgba(0,0,0,0.05);
  }
  .gender-item:active {
    transition: ease-in-out 0.3s;
    background-color: rgba(0,0,0,0.1);
  }
  .gender-item.selected,
  .gender-item.selected:hover,
  .gender-item.selected:active {
    transition: ease-in-out 0.3s;
    font-weight: bold;
    color: black;
    background-color: white;
  }
</style>